import { useMeeting } from "@videosdk.live/react-sdk";
import { useEffect, useRef } from "react";
import { useMeetingAppContext } from "../MeetingAppContextDef";

const useExternalPlayer = () => {
  const mMmeeting = useMeeting();

  const { setExternalvideoPlayer } = useMeetingAppContext();

  const setExternalvideoPlayerRef = useRef();

  useEffect(() => {
    setExternalvideoPlayerRef.current = setExternalvideoPlayer;
  }, [setExternalvideoPlayer]);

  const handleExternalvideoplayer = (state) => {
    if (state?.status === "started") {
      setExternalvideoPlayer({
        started: true,
        link: state?.link,
      });
    } else {
      setExternalvideoPlayer({
        started: false,
        link: null,
      });
    }
  };

  useEffect(() => {
    if (mMmeeting?.meeting) {
      mMmeeting?.meeting?.on("video-state-changed", handleExternalvideoplayer);
    }
  }, [mMmeeting]);
};

export default useExternalPlayer;
